  <!-- Messages -->
  <app-messages [hidden]="mode !== 'messages'" (conversationSelect)="conversationSelected($event)"
    (messagesClosed)="closeMessages()"></app-messages>
  <!-- Conversations -->
  <app-conversation *ngIf="mode === 'conversation'" [conversationId]="activeConversationId" [conversationOptions]="activeConversationOptions"
    (conversationClosed)="conversationClosed()"></app-conversation>